/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Checking_ConnectionInputs */

const en_home_v2_checking_connection = /** @type {(inputs: Home_V2_Checking_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking connection…`)
};

const es_home_v2_checking_connection = /** @type {(inputs: Home_V2_Checking_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprobando conexión…`)
};

/**
* | output |
* | --- |
* | "Checking connection…" |
*
* @param {Home_V2_Checking_ConnectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_checking_connection = /** @type {((inputs?: Home_V2_Checking_ConnectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Checking_ConnectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_checking_connection(inputs)
	return en_home_v2_checking_connection(inputs)
});